/**
 * Sebutan unit terkecil, loaded for the whole shell: every parish's word on this device
 * (`pengaturan:sebutan`), read when the shell mounts and again 250 ms after each sync-state
 * change (a save, a pulled page), into ./sebutanUnit's store.
 */
import { useEffect } from 'react'
import { getDb } from '../db'
import { useSebutanUnitStore } from './sebutanUnit'
import { useUi } from './ui'

const JEDA_MS = 250

/** Reads every parish's word on this device now and 250 ms after each sync-state change. */
export function useMuatSebutanUnit(): void {
  useEffect(() => {
    let hidup = true
    let jam: ReturnType<typeof setTimeout> | null = null
    const muat = () => {
      const db = getDb()
      db.ready
        .then(() => db.requestRaw('pengaturan:sebutan', {}))
        .then(
          (peta) => {
            if (hidup && typeof peta === 'object' && peta !== null) {
              useSebutanUnitStore.setState({ peta: peta as Record<string, string> })
            }
          },
          () => {
            // The word stays as last read (the default before any): the next change asks again.
          },
        )
    }
    muat()
    const lepas = useUi.subscribe((kini, sebelum) => {
      if (kini.sync === sebelum.sync) return
      if (jam !== null) clearTimeout(jam)
      jam = setTimeout(() => {
        jam = null
        muat()
      }, JEDA_MS)
    })
    return () => {
      hidup = false
      lepas()
      if (jam !== null) clearTimeout(jam)
    }
  }, [])
}
